import NotificationProvider from './NotificationProvider'

export default NotificationProvider